import axios from '@/api/axios'

const createAthleteResult = athleteResult => {
  return axios.post('/athleteResult', athleteResult)
}

const getAthletesResult = () => {
  return axios.get('/athleteResult')
}

const getAthleteResult = id => {
  return axios.get(`/athleteResult/${id}`)
}

const updateAthleteResult = (id, athleteResultInput) => {
  return axios.put(`/athleteResult/${id}`, athleteResultInput)
}

const deleteAthleteResult = id => {
  return axios.delete(`/athleteResult/${id}`)
}

const getAthletesResultById = params => {
  return axios.get(`/athleteResult${params}`).then(res => res.data)
}

export default {
  createAthleteResult,
  getAthletesResult,
  getAthleteResult,
  updateAthleteResult,
  deleteAthleteResult,
  getAthletesResultById
}
